import api from "../api.js";
import DeviceTypes from "./DeviceTypes.js";

/**
 * Device service
 *
 * Enables API interactions with device records.
 */
class DeviceService {

	/**
	 * Get a device's registration data by its device type and token.
	 *
	 * @param {String} deviceToken
	 * @param {String} deviceToken
	 * @return {Promise}
	 */
	static getDeviceHeartbeat(deviceType) {

		switch (deviceType) {
			/*
			 * case DeviceTypes.TimeRegister:
			 * return api.call({url: `signin_api_device.php?device=${deviceToken}&sync_count=null&sync_time=null`}).then(({data}) => data);
			 */
			case DeviceTypes.POS:
				return api.call({url: `/api/pos/devices/heartbeat`}).then(({data}) => data);
			case DeviceTypes.Fulfilment:
				return api.call({url: `/api/fulfilment/devices/heartbeat`}).then(({data}) => data);
			default:
				return Promise.resolve();
		}
	}

	/**
	 * Get a device's registration data by its device type and token.
	 *
	 * @param {String} deviceToken
	 * @param {String} deviceToken
	 * @return {Promise}
	 */
	static getDeviceRegistration(deviceType, deviceToken) {

		switch (deviceType) {
			case DeviceTypes.TimeRegister:
				return api.call({url: `signin_api_device.php?device=${deviceToken}&sync_count=null&sync_time=null`}).then(({data}) => data);
			case DeviceTypes.POS:
				return api.call({url: `/api/pos/devices/${deviceToken}/registration`}).then(({data}) => data);
			case DeviceTypes.Fulfilment:
				return api.call({url: `/api/fulfilment/devices/${deviceToken}/registration`}).then(({data}) => data);
			default:
				return Promise.resolve();
		}
	}

}

export default DeviceService;
